import React from "react";
import { Link, NavLink, Redirect, useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPhone, mdiWhatsapp } from "@mdi/js";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import Faq, { faqJsonLd } from "../components/Faq";
import SavingsCalculator from "../components/SavingsCalculator";
import ContactForm from "../components/ContactForm";
import { services, getService } from "../content/services";
import { useSite } from "../theme/ThemeProvider";

const ServiceDetail = () => {
  const { slug } = useParams();
  const site = useSite();
  const s = getService(slug);
  if (!s) return <Redirect to="/hizmetler" />;

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: s.title,
      description: s.seoDescription,
      provider: { "@type": "AutoRepair", name: site.name, url: site.url },
      areaServed: ["Yalova", "Altınova", "Kaytazdere", "Karamürsel"],
      url: `${site.url}/hizmetler/${s.slug}`,
    },
  ];
  if (s.faq?.length) jsonLd.push(faqJsonLd(s.faq));

  return (
    <Layout>
      <Seo title={s.seoTitle || s.title} description={s.seoDescription} path={`/hizmetler/${s.slug}`} image={s.image} jsonLd={jsonLd} />
      <PageHero title={s.title} text={s.short} crumbs={[{ label: "Hizmetler", to: "/hizmetler" }, { label: s.title }]} />

      <section className="section">
        <div className="container">
          <div className="service-detail">
            <div className="service-detail__main">
              <img src={s.image} alt={s.title} />
              <div>
                <p className="lead">{s.intro}</p>
              </div>
              <div>
                <h2>Neler yapıyoruz?</h2>
                <ul className="check-list check-list--2col">
                  {s.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              </div>
              {s.steps?.length > 0 && (
                <div>
                  <h2>Süreç nasıl işliyor?</h2>
                  <div className="timeline">
                    {s.steps.map((st) => (
                      <div className="timeline__item" key={st.title}>
                        <h4>{st.title}</h4>
                        <p>{st.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {s.faq?.length > 0 && (
                <div>
                  <h2>Sık sorulan sorular</h2>
                  <Faq items={s.faq} />
                </div>
              )}
              <div className="card card__body">
                <h3>{s.title} için teklif isteyin</h3>
                <p className="muted">Aracınızın bilgilerini yazın, aynı gün fiyat ve randevu bilgisi verelim.</p>
                <ContactForm defaultService={s.title} />
              </div>
            </div>
            <aside className="service-detail__aside">
              <div className="cta-card">
                <h3>Hemen ulaşın</h3>
                <p>Telefonla ya da WhatsApp'tan yazın; sorularınızı yanıtlayalım.</p>
                <div className="cta-card__actions">
                  <a href={`tel:${site.phoneHref}`} className="btn btn--accent">
                    <Icon path={mdiPhone} /> {site.phone}
                  </a>
                  <a href={`https://wa.me/${site.whatsapp}`} target="_blank" rel="noreferrer" className="btn btn--outline-light">
                    <Icon path={mdiWhatsapp} /> WhatsApp
                  </a>
                </div>
              </div>
              <div className="card card__body">
                <h4 style={{ marginBottom: 12 }}>Diğer hizmetler</h4>
                <ul className="aside-list">
                  {services.map((o) => (
                    <li key={o.slug}>
                      <NavLink to={`/hizmetler/${o.slug}`} activeClassName="active">
                        <Icon path={o.icon} /> {o.title}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {s.slug === "lpg-montaj" && <SavingsCalculator />}

      <section className="section section--tight">
        <div className="container text-center">
          <Link to="/hizmetler" className="btn btn--outline">
            Tüm hizmetlere dön
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default ServiceDetail;
